<template>
  <span>
    <a-popover placement="right">
      <template slot="content">
        <p>This booking is allocated to truck {{ truckPlate }}</p>
        <small>*Click the icon to monitor the truck</small>
      </template>
      <i
        class="fa fa-truck"
        aria-hidden="true"
        style="cursor: pointer;"
        @click="openModal"
      ></i>
    </a-popover>
    <a-modal :title="title" v-model="visible" @ok="visible = false">
      <a-spin v-if="loading" tip="Loading..." />
      <GmapMap
        v-show="!loading"
        style="margin: -24px; height:300px"
        :zoom="mapParams.zoom"
        :center="mapParams.center"
      >
        <Gmap-Marker
          v-if="!loading && truck.currentLocation"
          :position="{
            lat: Number(truck.currentLocation.data.lat),
            lng: Number(truck.currentLocation.data.lng)
          }"
          :icon="{
            path:
              truck.stopped ||
              (truck.currentLocation && !truck.currentLocation.data.status)
                ? 0
                : 2,
            scale:
              truck.stopped ||
              (truck.currentLocation && !truck.currentLocation.data.status)
                ? 5
                : 3,
            rotation: Number(truck.currentLocation.data.course_over_ground)
          }"
          @click="infoWindow = truck"
        >
        </Gmap-Marker>
        <Gmap-Info-Window
          v-if="infoWindow !== null"
          :opened="infoWindow !== null"
          :position="{
            lat: infoWindow.currentLocation.data.lat,
            lng: infoWindow.currentLocation.data.lng
          }"
          @closeclick="infoWindow = null"
        >
          {{ infoWindow.description }}
          <br />{{ infoWindow.currentLocation.data.speed }}km/h,
          {{ moment(infoWindow.currentLocation.data.time).fromNow() }} ({{
            moment(infoWindow.currentLocation.data.time).format(
              "h:mm:ss a, ddd Do MMM 'YY"
            )
          }}) <br /><strong>Ignition:</strong>
          {{ infoWindow.currentLocation.data.status ? "On" : "Off" }} <br /><b
            >Location: </b
          >{{ infoWindow.currentLocation.data.location }}
        </Gmap-Info-Window>
      </GmapMap>
    </a-modal>
  </span>
</template>

<script>
import moment from "moment";

export default {
  name: "TruckMap",
  props: {
    truckId: {
      type: String
    },
    truckPlate: {
      type: String
    }
  },
  data() {
    return {
      visible: false,
      loading: false,
      truck: {},
      infoWindow: null
    };
  },
  methods: {
    moment,
    loadTruckById(truckId) {
      this.loading = true;
      api
        .get("/carrier/gps/trucks/" + truckId, {
          params: {
            includes: "currentLocation"
          }
        })
        .then(response => {
          this.truck = response.data.data;
        })
        .catch(error => {
          console.log(error);
        })
        .then(() => {
          this.loading = false;
        });
    },
    loadTruckByPlate(truckPlate) {
      this.loading = true;
      api
        .get("/carrier/gps/trucks/findByPlate", {
          params: {
            plate: truckPlate,
            includes: "currentLocation"
          }
        })
        .then(response => {
          if (response.status === 204) {
            throw "Truck Not Found";
          }
          this.truck = response.data.data;
        })
        .catch(error => {
          console.log(error);
        })
        .then(() => {
          this.loading = false;
        });
    },
    openModal() {
      this.visible = true;
      if (this.truckId != null) {
        console.log("Truck " + this.truckId + " is loading...");
        this.loadTruckById(this.truckId);
      } else if (this.truckPlate != null) {
        console.log("Truck " + this.truckPlate + " is loading...");
        this.loadTruckByPlate(this.truckPlate);
      } else {
        console.log("Please provide Truck Id or Plate...");
      }
    }
  },
  computed: {
    title: function() {
      if (this.loading) {
        return "Loading Truck Info...";
      }
      if (this.truck.currentLocation) {
        return this.truck.plate + " Latest Location";
      }
      return "Sorry, No Truck Info";
    },
    mapParams: function() {
      if (!this.loading && this.truck.currentLocation) {
        return {
          center: {
            lat: Number(this.truck.currentLocation.data.lat),
            lng: Number(this.truck.currentLocation.data.lng)
          },
          zoom: 12
        };
      }
      return {
        center: {
          lat: -41.543,
          lng: 174.0277
        },
        zoom: 6
      };
    }
  }
};
</script>

<style scoped>
.content {
  text-align: center;
}

.ant-popover-inner-content p {
  margin-bottom: 0;
}
</style>
